import { useNavigate } from "react-router-dom";
import {
  MdBrush,
  MdPhotoSizeSelectActual,
  MdVideoCameraBack,
  MdAutoAwesome,
  MdGridView,
  MdMovieFilter,
  MdPlayCircle,
} from "react-icons/md";
import { PROJECTS } from "../../data/Design";
import "./homeDesignSec.scss";

// Pick 7 curated samples – a variety of image & video work
const SAMPLE_IDS = [4, 6, 7, 43, 8, 14, 18];
const sampleWorks = PROJECTS.filter((p) => SAMPLE_IDS.includes(p.id));

const services = [
  {
    icon: <MdBrush />,
    title: "Brand Identity",
    desc: "Logos, color palettes, and full brand systems crafted to make your business instantly recognizable.",
    tag: "Branding",
  },
  {
    icon: <MdPhotoSizeSelectActual />,
    title: "Social Media Design",
    desc: "Eye-catching posts, stories, and reels artwork designed to stop the scroll and boost engagement.",
    tag: "Digital",
  },
  {
    icon: <MdVideoCameraBack />,
    title: "Video Editing",
    desc: "Cinematic cuts, color grading, and motion graphics that bring your footage to life.",
    tag: "Motion",
  },
  {
    icon: <MdAutoAwesome />,
    title: "UI / UX Design",
    desc: "Clean, intuitive interfaces and wireframes that blend aesthetics with flawless user experience.",
    tag: "UI/UX",
  },
  {
    icon: <MdGridView />,
    title: "Print & Publications",
    desc: "Flyers, brochures, banners, and editorial layouts designed with precision for print and digital.",
    tag: "Print",
  },
  {
    icon: <MdMovieFilter />,
    title: "Motion Graphics",
    desc: "Animated intros, lower thirds, and dynamic visual content crafted in Premiere Pro & After Effects.",
    tag: "Animation",
  },
];

const tools = [
  "Adobe Photoshop",
  "Adobe Illustrator",
  "Figma",
  "Adobe XD",
  "Premiere Pro",
  "After Effects",
  "Lightroom",
];

const HomeDesignSec = () => {
  const navigate = useNavigate();

  return (
    <section className="hd-section">
      {/* Decorative blobs */}
      <div className="hd-blob hd-blob--tl" aria-hidden="true" />
      <div className="hd-blob hd-blob--br" aria-hidden="true" />

      <div className="hd-container">

        {/* ── HEADER ── */}
        <div className="hd-header" data-aos="fade-up">
          <span className="hd-eyebrow">Creative Studio</span>
          <h2 className="hd-title">
            Graphic Design &amp; <span className="hd-title--gold">Creative</span> Services
          </h2>
          <p className="hd-subtitle">
            From brand identities to motion graphics — I turn ideas into
            striking visuals that communicate, inspire, and leave a lasting impression.
          </p>
        </div>

        {/* ── SERVICE GRID ── */}
        <div className="hd-grid">
          {services.map((svc, i) => (
            <div
              className="hd-card"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 70}
            >
              <div className="hd-card__top">
                <div className="hd-card__icon">{svc.icon}</div>
                <span className="hd-card__tag">{svc.tag}</span>
              </div>
              <h3 className="hd-card__title">{svc.title}</h3>
              <p className="hd-card__desc">{svc.desc}</p>
              <div className="hd-card__line" />
            </div>
          ))}
        </div>

        {/* ── SAMPLE WORKS ── */}
        <div className="hd-samples" data-aos="fade-up" data-aos-delay="80">
          <div className="hd-samples__header">
            <span className="hd-samples__label">Sample Works</span>
            <div className="hd-samples__line" />
          </div>
          <div className="hd-samples__mosaic">
            {sampleWorks.map((item, i) => (
              <div
                className={`hd-sample-tile hd-sample-tile--${i}`}
                key={item.id}
                data-aos="fade-up"
                data-aos-delay={i * 60}
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="hd-sample-tile__img"
                  loading="lazy"
                />
                <div className="hd-sample-tile__overlay">
                  {item.type === "video" && (
                    <MdPlayCircle className="hd-sample-tile__play" />
                  )}
                  <div className="hd-sample-tile__meta">
                    <span className="hd-sample-tile__cat">{item.category}</span>
                    <h4 className="hd-sample-tile__title">{item.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── TOOLS STRIP ── */}
        <div className="hd-tools" data-aos="fade-up" data-aos-delay="100">
          <span className="hd-tools__label">Tools I work with</span>
          <div className="hd-tools__badges">
            {tools.map((tool, i) => (
              <span className="hd-badge" key={i}>{tool}</span>
            ))}
          </div>
        </div>

        {/* ── CTA ── */}
        <div className="hd-cta" data-aos="fade-up" data-aos-delay="150">
          <button
            className="hd-btn"
            onClick={() => navigate("/service")}
            aria-label="View all graphic design work"
          >
            <span className="hd-btn__text-1">View My Work</span>
            <span className="hd-btn__text-2">Explore Gallery</span>
          </button>
        </div>

      </div>
    </section>
  );
};

export default HomeDesignSec;